function truncate(t, l, s) {
  if (t) {
    if (t.length < l) return t;
    else return t.substring(0, l) + s;
  }
}
export default truncate;
